/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

 // You can delete this file if you're not using it

import ReactGA from 'react-ga';

function callAnalyticsAPI() {
  ReactGA.initialize('UA-99563140-2');
  ReactGA.pageview(window.location.pathname + window.location.search);
}

exports.onClientEntry = () => {
  callAnalyticsAPI()
}


// WEBPACK FOOTER //
// ./gatsby-browser.js